import {
  SEARCH_COMUNI_CITTADINANZA,
  SEARCH_COMUNI_LUOGO_NASCITA,
  SEARCH_COMUNI_RESIDENZA,
  SEARCH_LUOGO_EMISSIONE_CARTAIDENTITA,
  SEARCH_LUOGO_EMISSIONE_PASSAPORTO,
  SEARCH_LUOGO_EMISSIONE_PATENTE,
} from '../../constants/ActionTypes'
import { createBasicCreator, fetchData, GET_NAZIONI, newNazioni } from '../Buy'

export const getComuniNazioniV1 = dispatch =>
  dispatch(
    fetchData(GET_NAZIONI)({
      method: 'GET',
      uri: `${window.brumbrum.url_api}/comuni/p/v1/list/nazioni/complete/all`,
      callback: newNazioni,
      errorMessage: GET_NAZIONI,
    })
  )

export const searchComuniV2LuogoNascita = searchQuery => dispatch =>
  dispatch(
    fetchData(SEARCH_COMUNI_LUOGO_NASCITA)({
      method: 'GET',
      fetchingDisabled: true,
      uri: `${window.brumbrum.url_api}/comuni/p/v2/search/luogo-nascita?filtro=${searchQuery}`,
      callback: createBasicCreator(SEARCH_COMUNI_LUOGO_NASCITA),
      errorMessage: SEARCH_COMUNI_LUOGO_NASCITA,
    })
  )

export const searchComuniV2Cittadinanza = searchQuery => dispatch =>
  dispatch(
    fetchData(SEARCH_COMUNI_CITTADINANZA)({
      method: 'GET',
      fetchingDisabled: true,
      uri: `${window.brumbrum.url_api}/comuni/p/v2/search/luogo-nascita?filtro=${searchQuery}&tipo=cittadinanza`,
      callback: createBasicCreator(SEARCH_COMUNI_CITTADINANZA),
      errorMessage: SEARCH_COMUNI_CITTADINANZA,
    })
  )

export const searchComuniV2Residenza = searchQuery => dispatch =>
  dispatch(
    fetchData(SEARCH_COMUNI_RESIDENZA)({
      method: 'GET',
      fetchingDisabled: true,
      uri: `${window.brumbrum.url_api}/comuni/p/v2/search/comuni-attivi?filtro=${searchQuery}`,
      callback: createBasicCreator(SEARCH_COMUNI_RESIDENZA),
      errorMessage: SEARCH_COMUNI_RESIDENZA,
    })
  )

export const searchComuniV2PassportEmission = searchQuery => dispatch =>
  dispatch(
    fetchData(SEARCH_LUOGO_EMISSIONE_PASSAPORTO)({
      method: 'GET',
      fetchingDisabled: true,
      uri: `${window.brumbrum.url_api}/comuni/p/v2/search/luoghi-emissione-passaporto?filtro=${searchQuery}`,
      callback: createBasicCreator(SEARCH_LUOGO_EMISSIONE_PASSAPORTO),
      errorMessage: SEARCH_LUOGO_EMISSIONE_PASSAPORTO,
    })
  )

export const searchComuniV2LicenseEmission = searchQuery => dispatch =>
  dispatch(
    fetchData(SEARCH_LUOGO_EMISSIONE_PATENTE)({
      method: 'GET',
      fetchingDisabled: true,
      uri: `${window.brumbrum.url_api}/comuni/p/v2/search/luoghi-emissione-patente?filtro=${searchQuery}`,
      callback: createBasicCreator(SEARCH_LUOGO_EMISSIONE_PATENTE),
      errorMessage: SEARCH_LUOGO_EMISSIONE_PATENTE,
    })
  )

export const searchComuniV2IdentityCardEmission = searchQuery => dispatch =>
  dispatch(
    fetchData(SEARCH_LUOGO_EMISSIONE_CARTAIDENTITA)({
      method: 'GET',
      fetchingDisabled: true,
      uri: `${window.brumbrum.url_api}/comuni/p/v2/search/luoghi-emissione-carta-identita?filtro=${searchQuery}`,
      callback: createBasicCreator(SEARCH_LUOGO_EMISSIONE_CARTAIDENTITA),
      errorMessage: SEARCH_LUOGO_EMISSIONE_CARTAIDENTITA,
    })
  )
